import { PencilSimple } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IContactGroup } from 'contacts/types';
import { Button } from 'core/components';
import { Color } from 'theme/enums';

import { UpdateContactGroup } from './UpdateContactGroup';

interface IProps {
  contactGroup?: IContactGroup;
  onSubmitSuccess?: (contactGroup: IContactGroup) => void;
}

export const UpdateContactGroupButton = ({ contactGroup, onSubmitSuccess }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  return (
    <>
      <Button
        text={t('buttonLabelEdit')}
        color={Color.PRIMARY}
        startDecorator={<PencilSimple />}
        onClick={() => setIsOpen(true)}
      />

      <UpdateContactGroup
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        contactGroup={contactGroup}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
